export const MAKE_READY_SERVICE_CATEGORY_SLUGS: (string | undefined)[] = ['make-ready', 'make-ready-quote'];

export const isMakeReadyServiceCategory = (
  type?: string,
  slug?: string,
): boolean => MAKE_READY_SERVICE_CATEGORY_SLUGS.includes(type) || MAKE_READY_SERVICE_CATEGORY_SLUGS.includes(slug);

export const updateUrlForOpenJobSidePanel = (
  id: string | number,
  type: string,
  jobId: string | number,
  srId: string | number,
  activeTab: string = 'activityLog',
) => {
  const url = new URL(window?.location?.href);
  url?.searchParams?.delete('mr');
  url?.searchParams?.delete('jobId');
  if (url) {
    url?.searchParams?.set(type === 'jobDetails' ? 'jobId' : 'mr', String(id));
    window?.history?.pushState({ jobId: id, type }, '', url);
    const event = new CustomEvent('openJobSidePanel', {
      detail: {
        activeItemNumber: id, type, jobId, srId: Number(srId), activeTab,
      },
    });
    document.dispatchEvent(event);
  }
};
